export default __webpack_public_path__ + "static/media/SH.0f69b595.ico";